import script from "./CxTextArea.vue?vue&type=script&setup=true&lang=ts"
export * from "./CxTextArea.vue?vue&type=script&setup=true&lang=ts"

import "./CxTextArea.vue?vue&type=style&index=0&id=04e8380b&lang=less&scoped=true"

import exportComponent from "/home/ec2-user/workspace/_conx-ui-monorepo_ui2_lab_master/apps/ui2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04e8380b"]])

export default __exports__